module.exports = __webpack_public_path__ + "media/images/application2/AppNav__panel__actions__a--logout-c4ae735620657e40ffd4add46e7c1118.svg";